<template>

  <v-menu bottom left offset-y :disabled="!loggedInAndLive" style="z-index: 1000;">

    <template v-slot:activator="{ on, attrs }">
      <v-btn class="ml-1" icon small color="accent" v-bind="attrs" v-on="on" >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item-group color="primary" >
 
        <AppMenuItem icon="mdi-pine-tree" :to="{name: 'Trees'}" :title="$t('trees')" />
        <AppMenuItem icon="mdi-currency-usd-circle-outline" :to="{name: 'SkuIndex'}" :title="$t('skus')" v-if="skus" />
        <AppMenuItem icon="mdi-source-branch" :to="{name: 'About'}" :title="$t('about')" />


        <v-list-item  @click="signOut" style="cursor: pointer">
          <v-icon color="primary" class="mr-4" dense>mdi-logout</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('logout')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list-item-group>

    </v-list>

  </v-menu>

</template>

<script>
import AppMenuItem from '@/components/AppMenuItem';

export default {
  components: {
    AppMenuItem,
  },
  computed: {
    loggedInAndLive() { return this.$store.getters.venueId!==null; },
    skus() { return (this.$store.getters.settings.skus || []).filter( e => e ).length>0; },
  },
  methods: {
    signOut() {
      this.$store.dispatch('logout');
      this.$router.push({name: 'Home'});
    },
  }

};
</script>


<i18n>
{
  "en": {
    "skus": "Prices",
    "about": "About",
    "logout": "Sign Out"
  },
  "es": {
    "skus": "Precios",
    "about": "Acerca de",
    "logout": "Desconectar"
  },
  "sw": {
    "skus": "Bei",
    "about": "Kuhusu",
    "logout": "Ondoka"
  }
}
</i18n>
